import { AxiosInstance } from 'axios';
import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { loadRemoteModule } from 'moduleFederation/moduleFederationRuntime';
import { Config } from '../../config';

type InitApiService = (
  axiosInstance: AxiosInstance,
  smBaseUrl: string | false,
  aiBaseUrl?: string | false
) => void;

const initAiServicesApiClients = async () => {
  try {
    const { default: initApiService } = await loadRemoteModule<{ default: InitApiService }>(
      'aiservices/initApiService'
    );

    initApiService?.(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.SM,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.AI
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initAiServicesApiClients', e);
  }
};

export default initAiServicesApiClients;
